import preuseTests from "../preuse_tests.json";

/** test_id → display name from `preuse_tests.json` */
export const TEST_NAME_MAP = Object.fromEntries(preuseTests.map((t) => [t.test_id, t.test_name]));
